import Axios from 'axios';

export const HTTP = Axios.create({
  baseURL: `${process.env.API_URL}/V1`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export function setAuthorization(token) {
  HTTP.defaults.headers.common.Authorization = token;
}

export function clearAuthorization() {
  delete HTTP.defaults.headers.common.Authorization;
}

const HTTP_CONF = Axios.create({
  baseURL: '/',
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export function getRuntimeConfig() {
  return HTTP_CONF.get('/static/config/runtime.json')
    .then(response => response.data);
}



// WEBPACK FOOTER //
// ./src/http.js